module.exports = __webpack_public_path__ + "img/img_1.f3ef17e7.webp";